<div class="main_settings">
  <app-settings-sidebar></app-settings-sidebar>
  <div class="main_content">
    <router-outlet 
      (activate)='onActivate($event)' 
      (deactivate)='onDeactivate($event)'
    ></router-outlet>
  </div>
</div>